import { useEffect, useState, useMemo } from "react";
import { postAxios } from "../../../util/postAxios";
import { mock } from "../../../constant";
import { today } from "../../../util/formatDate";
import moment from "moment";
import * as XLSX from "xlsx";

export const useApar = () => {
  const getToken = localStorage.getItem("auth")
    ? localStorage.getItem("auth")
    : null;

  const getTim = localStorage.getItem("user");
  const dataUser = JSON.parse(getTim);

  const [subMenu, setSubMenu] = useState("monitoring");
  const [filterMesin, setFilterMesin] = useState("1");
  const [filterTahun, setFilterTahun] = useState(
    moment().utcOffset("+0700").year()
  );

  const [listApar, setListApar] = useState();

  const [showQrCode, setShowQrCode] = useState(false);
  const [pickQrCode, setPickQrCode] = useState();

  const [listStatusApar, setListStatusApar] = useState();

  const [filterLantai, setFilterLantai] = useState("1");
  const [listChecksheet, setListChecksheet] = useState();

  const [listInOut, setListInOut] = useState();
  const [dateApar, setDateApar] = useState(today);
  const [filterNoApar, setFilterNoApar] = useState("Pilih Apar");

  const [sortApar, setSortApar] = useState("asc");

  useEffect(() => {
    if (subMenu === "Inventory") {
      postAxios(
        `${process.env.REACT_APP_ENDPOINT}/getListApar`,
        { tim: dataUser.tim, lantai: "" },
        getToken,
        setListApar,
        ""
      );
    }
    if (subMenu === "monitoring") {
      postAxios(
        `${process.env.REACT_APP_ENDPOINT}/getListApar`,
        { tim: dataUser.tim, lantai: filterLantai },
        getToken,
        setListStatusApar,
        ""
      );
    }
    if (subMenu === "checksheet") {
      postAxios(
        `${process.env.REACT_APP_ENDPOINT}/getRiwayatApar`,
        {
          tim: dataUser.tim,
          type: "checksheet",
          year: Number(filterTahun),
          noApar: filterMesin,
        },
        getToken,
        setListChecksheet,
        ""
      );
    }
  }, [subMenu, filterLantai, filterTahun, filterMesin]);

  useEffect(() => {
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/postNotification`,
      {
        tim: dataUser.tim,
        type: "APAR",
      },
      getToken,
      "",
      ""
    );
  }, []);

  const dataMerge = useMemo(() => {
    const copy = JSON.parse(JSON.stringify(mock));

    listChecksheet &&
      listChecksheet.forEach((element) => {
        for (let i = 1; i <= 14; i++) {
          const itemIndex = copy.findIndex((item) => item.itemId === String(i));

          if (itemIndex !== -1) {
            const qProperty = `q${i}`;
            copy[itemIndex].month.push({
              monthId: element.month,
              itemId: String(i),
              checklist: element[qProperty],
              petugas: element.petugas,
            });
          }
        }
      });
    return copy;
  }, [listChecksheet]);

  useEffect(() => {
    if (subMenu === "InOut") {
      postAxios(
        `${process.env.REACT_APP_ENDPOINT}/getRiwayatApar`,
        {
          tim: dataUser.tim,
          type: "InOut",
          filterDate: dateApar,
        },
        getToken,
        setListInOut,
        ""
      );
    }
  }, [filterNoApar, dateApar]);

  const searchFeature = () => {
    if (filterNoApar !== "Pilih Apar") {
      let searchName = [];
      listInOut &&
        listInOut.forEach((value) => {
          if (value.noApar === filterNoApar) {
            searchName.push(value);
          }
        });
      return searchName;
    } else {
      return listInOut && listInOut;
    }
  };
  const sortByNoApar = (list) => {
    if (!list) return list;
    const arah = sortApar === "asc" ? 1 : -1;
    return [...list].sort(
      (a, b) =>
        String(a.noApar).localeCompare(String(b.noApar), undefined, {
          numeric: true,
        }) * arah
    );
  };

  let dataTemp = sortByNoApar(searchFeature());
  const listAparSorted = sortByNoApar(listApar);

  const exportKadaluarsa = () => {
    let dataObject = [];

    listApar &&
      listApar.map((obj) => {
        let tglKadaluarsa = obj.kadaluarsa;

        let today = moment().utcOffset("+0700").format();

        let validateKadaluarsa = new Date(tglKadaluarsa) <= new Date(today);

        dataObject.push({
          NoApar: obj.noApar,
          Jenis: obj.jenis,
          Lantai: obj.lantai,
          Kadaluarsa: moment(tglKadaluarsa)
            .utcOffset("+0700")
            .format("DD-MM-YYYY"),
          Status: obj.isKeluar ? "KELUAR" : "AKTIF",
          "": validateKadaluarsa ? "KADALUARSA" : "",
        });
      });

    const workSheet = XLSX.utils.json_to_sheet(dataObject);
    workSheet["!cols"] = [
      { wch: 8 },
      { wch: 10 },
      { wch: 15 },
      { wch: 13 },
      { wch: 8 },
      { wch: 12 },
    ];
    const workBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workBook, workSheet, "Data Gaji");
    XLSX.write(workBook, { bookType: "xlsx", type: "buffer" });
    XLSX.write(workBook, { bookType: "xlsx", type: "binary" });
    XLSX.writeFile(workBook, `Data APAR.xlsx`);
  };

  return {
    subMenu,
    setSubMenu,
    dataMerge,
    filterMesin,
    setFilterMesin,
    filterTahun,
    setFilterTahun,
    listApar,
    showQrCode,
    setShowQrCode,
    pickQrCode,
    setPickQrCode,
    listStatusApar,
    filterLantai,
    setFilterLantai,
    dateApar,
    setDateApar,
    filterNoApar,
    setFilterNoApar,
    dataTemp,
    exportKadaluarsa,
    listApar: listAparSorted,
    sortApar,
    setSortApar,
  };
};
